import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { default as sessionReducer } from './reducers/session';
import { default as entitiesReducer } from './reducers/entities';
import storage from 'redux-persist/lib/storage/session';
import { persistReducer, persistStore } from 'redux-persist';
import { sessionTransform } from './transforms/sessionTransform';
import { entitiesTransform } from './transforms/entitiesTransform';

const applicationReducers = combineReducers({
  session: sessionReducer,
  entities: entitiesReducer,
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['session', 'entities'],
  transforms: [sessionTransform, entitiesTransform],
};

const persistedReducer = persistReducer(persistConfig, applicationReducers);

export const applicationStore = configureStore({
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  reducer: persistedReducer,
});

export type ApplicationState = ReturnType<typeof applicationReducers>;

export const applicationPersiStore = persistStore(applicationStore);
